/**
 * Каноничные имена клиентских событий продуктовой аналитики.
 *
 * Бэк НЕ валидирует event_type (свободная строка): опечатка молча потеряет
 * событие, незадокументированное имя не попадёт в воронку. Поэтому имена
 * держим только здесь и нигде не пишем строками руками. Источник истины —
 * дока «Virtuoz Analytic Events».
 *
 * ВАЖНО: события завершения генерации/регистрации пишет БЭК сам по X-Session-Id
 * (text_generated, text_edited_ai, text_created_manual, song_generated,
 * guest_started, login для email/yandex) — фронт их НЕ шлёт.
 */
export const AnalyticsEvent = {
    // Навигация (backbone таймлайна)
    WEB_OPEN: "web_open", // воронка, шаг 1
    PAGE_VIEW: "page_view",
    // Воронка генерации (намерения)
    TEXT_GEN_SCREEN_OPEN: "text_gen_screen_open", // воронка, шаг 2 (зонтичное)
    REASON_SELECT: "reason_select",
    RECIPIENT_SELECT: "recipient_select",
    TEXT_GEN_START: "text_gen_start", // старт ИИ-генерации текста
    // Разбивка экрана генерации по режиму (доп. к text_gen_screen_open).
    TEXT_AI_VIEW: "text_ai_view", // таб «ИИ напишет»
    TEXT_MANUAL_VIEW: "text_manual_view", // таб «Свой»
    TEXT_HISTORY_VIEW: "text_history_view", // таб «Сохранённые»
    REASON_CUSTOM_INPUT: "reason_custom_input", // ввод своего повода (on blur)
    ABOUT_INPUT: "about_input", // ввод брифа «о ком/о чём» (on blur)
    TEXT_EDIT_START: "text_edit_start", // старт правки текста ИИ
    SONG_SETTINGS_OPEN: "song_settings_open", // переход на экран настроек песни
    // Работа со своими текстами
    TEXT_MANUAL_INPUT: "text_manual_input",
    TEXT_SEARCH: "text_search",
    TEXT_SELECT: "text_select",
    // Выбор параметров песни
    GENRE_SELECT: "genre_select",
    VOICE_SELECT: "voice_select",
    MOOD_SELECT: "mood_select",
    MOOD_DISELECT: "mood_diselect", // снятие выбора настроения
    INSTRUMENT_SELECT: "instrument_select",
    INSTRUMENT_DISELECT: "instrument_diselect", // снятие выбора инструмента
    KEY_SELECT: "key_select",
    STYLE_EXTRA_INPUT: "style_extra_input", // ввод доп. описания стиля (on blur)
    SONG_GEN_START: "song_gen_start", // клик «Создать песню»
    // Профиль автора / прослушивание
    AUTHOR_PROFILE_VISIT: "author_profile_visit",
    AUTHOR_SONG_PLAY: "author_song_play",
    AUTHOR_SONG_FINISH: "author_song_finish",
    AUDIO_PAUSE: "audio_pause",
    // Оплата (намерения; факт оплаты — в payments)
    PACKAGES_VIEW: "packages_view",
    PAYWALL_VIEW: "paywall_view", // открыт пейвол-воронка (альтернатива packages_view для AB)
    BILLING_EMAIL_ENTERED: "billing_email_entered",
    PAYMENT_LINK_CREATED: "payment_link_created",
    // Оплата — возврат из платёжки
    PAYMENT_RETURN: "payment_return",
    // Авторизация (намерения; login для email/yandex пишет бэк)
    REGISTER_START: "register_start",
    LOGIN_START: "login_start",
    CODE_RESEND: "code_resend", // повторный запрос кода
    CODE_VERIFY_FAILED: "code_verify_failed", // неверный/просроченный код
    LOGIN: "login", // только мини-аппы (tg_miniapp/max_miniapp)
    // Прочее (опционально)
    SHARE_CLICK: "share_click",
    CTA_CLICK: "cta_click",
};
